// extracted by mini-css-extract-plugin
export var adjacentSlide = "_tp-9";
export var arrowButtonContainer = "_tp-5";
export var arrowButtonIcon = "_tp-6";
export var carouselArrowButton = "_tp-2";
export var carouselElementContainer = "_tp-1";
export var currentSlide = "_tp-8";
export var left = "_tp-3";
export var otherSlide = "_tp-a";
export var productCarouselContainer = "_tp-0";
export var right = "_tp-4";
export var sliderOverflow = "_tp-7";